import React from 'react';
import { TableBody, TableCell, TableRow } from '@material-ui/core';

import Table from '../components/Table/Table';
import ConfirmButton from '../components/Button/ConfirmButton';
import JoinForm from '../singup/JoinForm';

class UserInfoTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userInfo: {},
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.userInfo !== prevState.userInfo) {
      return { userInfo: nextProps.userInfo };
    } else {
      return null;
    }
  }

  componentDidMount() {}

  componentWillUnmount() {
    if (!this.props.isSummary && this.props.mode === 'modify') {
      this.props.handleState('userInfoMode', 'read');
    }
  }

  render() {
    const { mode, isSummary } = this.props;

    return (
      <>
        {mode === 'read' ? (
          <>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell component="th" width="25%">
                    <span>*</span> Country
                  </TableCell>
                  <TableCell>{this.state.userInfo && this.state.userInfo.country && this.state.userInfo.country}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th">
                    <span>*</span> ID(E-mail)
                  </TableCell>
                  <TableCell>{this.state.userInfo && this.state.userInfo.email && this.state.userInfo.email}</TableCell>
                </TableRow>
                {this.props.lang && this.props.lang === 'kor' && this.state.userInfo.kind !== '국내연수 외국인의사' && (
                  <TableRow>
                    <TableCell component="th">
                      <span>*</span> 성명(국문)
                    </TableCell>
                    <TableCell>{this.state.userInfo && this.state.userInfo.username && this.state.userInfo.username}</TableCell>
                  </TableRow>
                )}
                <TableRow>
                  <TableCell component="th">
                    <span>*</span> {this.props.lang && this.props.lang === 'kor' ? '성명(영문)' : 'Name'}
                  </TableCell>
                  <TableCell>
                    {this.state.userInfo &&
                      this.state.userInfo.firstName &&
                      this.state.userInfo.lastName &&
                      `${this.state.userInfo.firstName} ${this.state.userInfo.lastName}`}
                  </TableCell>
                </TableRow>
                {!isSummary &&
                  this.props.lang &&
                  this.props.lang === 'kor' &&
                  this.state.userInfo.kind !== '국내연수 외국인의사' &&
                  this.state.userInfo.kind !== '동반자' && (
                    <TableRow>
                      <TableCell component="th">
                        <span>*</span> 의사면허번호
                      </TableCell>
                      <TableCell>{this.state.userInfo && this.state.userInfo.license && this.state.userInfo.license}</TableCell>
                    </TableRow>
                  )}
                {!isSummary &&
                  this.props.lang &&
                  this.props.lang === 'kor' &&
                  (this.state.userInfo.kind === '국내연수 외국인의사' || this.state.userInfo.kind === '동반자') && (
                    <TableRow>
                      <TableCell component="th">
                        <span>*</span> 추천인
                      </TableCell>
                      <TableCell>
                        <p>성명: {this.state.userInfo.postalCode}</p>
                        <p>의사면허번호: {this.state.userInfo.license}</p>
                      </TableCell>
                    </TableRow>
                  )}
                <TableRow>
                  <TableCell component="th">
                    <span>*</span> Title
                  </TableCell>
                  <TableCell>{this.state.userInfo && this.state.userInfo.title && this.state.userInfo.title}</TableCell>
                </TableRow>
                {!isSummary && (
                  <>
                    {this.props.lang && this.props.lang !== 'kor' && (
                      <TableRow>
                        <TableCell component="th">
                          <span>*</span> Department
                        </TableCell>
                        <TableCell>{this.state.userInfo && this.state.userInfo.dept && this.state.userInfo.dept}</TableCell>
                      </TableRow>
                    )}
                    {this.props.lang && this.props.lang === 'kor' && (
                      <TableRow>
                        <TableCell component="th">
                          <span>*</span> 구분
                        </TableCell>
                        <TableCell>{this.state.userInfo && this.state.userInfo.kind && this.state.userInfo.kind}</TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell component="th">
                        <span>*</span> {this.props.lang && this.props.lang === 'kor' ? '소속(근무처)' : 'Affiliation'}
                      </TableCell>
                      <TableCell>
                        {this.props.lang && this.props.lang === 'kor' && (
                          <>
                            국문 : {this.state.userInfo && this.state.userInfo.position && this.state.userInfo.position}
                            <br />
                            영문 :{' '}
                          </>
                        )}
                        {this.state.userInfo && this.state.userInfo.positionEn && this.state.userInfo.positionEn}
                      </TableCell>
                    </TableRow>
                    {/* <TableRow>
                      <TableCell component="th">
                        <span>*</span> {this.props.lang && this.props.lang === 'kor' ? '주소' : 'Address'}
                      </TableCell>
                      <TableCell>
                        {this.state.userInfo && this.state.userInfo.postalCode && (
                          <>
                            {this.state.userInfo.postalCode}
                            <br />
                          </>
                        )}
                        {this.props.lang && this.props.lang === 'kor' && (
                          <>
                            국문 : {this.state.userInfo && this.state.userInfo.address && this.state.userInfo.address}
                            <br />
                            영문 :{' '}
                          </>
                        )}
                        {this.state.userInfo && this.state.userInfo.addressEn && this.state.userInfo.addressEn}
                      </TableCell>
                    </TableRow>
                    {this.props.lang && this.props.lang !== 'kor' && (
                      <TableRow>
                        <TableCell component="th">
                          <span>*</span> City
                        </TableCell>
                        <TableCell>{this.state.userInfo && this.state.userInfo.address && this.state.userInfo.address}</TableCell>
                      </TableRow>
                    )} */}
                    {/* <TableRow>
                <TableCell component="th">전문의 번호</TableCell>
                <TableCell>1234</TableCell>
              </TableRow> */}
                    <TableRow>
                      <TableCell component="th">
                        <span>*</span> {this.props.lang && this.props.lang === 'kor' ? '핸드폰 번호' : 'Mobile'}
                      </TableCell>
                      <TableCell>{this.state.userInfo && this.state.userInfo.hp && this.state.userInfo.hp}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th">{this.props.lang && this.props.lang === 'kor' ? '전화번호' : 'Telephone'}</TableCell>
                      <TableCell>
                        {this.state.userInfo && this.state.userInfo.tel && this.state.userInfo.tel !== '+---'
                          ? this.state.userInfo.tel
                          : ''}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell component="th">{this.props.lang && this.props.lang === 'kor' ? '기타사항' : 'Remark'}</TableCell>
                      <TableCell>{this.state.userInfo && this.state.userInfo.etc && this.state.userInfo.etc}</TableCell>
                    </TableRow>
                  </>
                )}
              </TableBody>
            </Table>
            {!isSummary && (
              <div style={{ textAlign: 'center', paddingTop: 24 }}>
                <ConfirmButton color="primary" onClick={() => this.props.handleState('userInfoMode', 'modify')}>
                  Modify
                </ConfirmButton>
              </div>
            )}
          </>
        ) : (
          <JoinForm
            isMypage={true}
            userId={this.state.userInfo && this.state.userInfo.id ? this.state.userInfo.id : ''}
            userInfo={this.state.userInfo}
            lang={this.props.lang}
            cancelModInfo={() => this.props.handleState('userInfoMode', 'read')}
          />
        )}
      </>
    );
  }
}

export default UserInfoTable;
